import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithAuth } from "../../BaseQueryWithAuth/baseQueryWithAuth";
import { queryParams } from "../../../utils/helper";

export const feedbackApiService = createApi({
  reducerPath: "feedbackApi",
  baseQuery: baseQueryWithAuth,
  endpoints: (builder) => ({
    createFeedback: builder.mutation({
      query: ({ payload, params }) => {
        let query = queryParams(params);
        return {
          url: `feedback/create${query}`,
          method: "POST",
          body: payload,
        };
      },
    }),
  }),
});

export const { useCreateFeedbackMutation } = feedbackApiService;
